<template>
    <div style="margin-left: 20px; margin-right:10%">
        <!-- Dialog dialog_start_test -->
        <v-layout row justify-center>
            <v-dialog v-model="dialog_start_test" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">Test starten?</v-card-title>
                    <v-card-text>
                        Wenn Sie "Ok" klicken, wird ein Testversuch verbraucht.
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" flat @click="ui_start_test('ok')">Ok</v-btn>
                        <v-btn color="green darken-1" flat @click="ui_start_test('cancel')">Abbrechen</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>


        <!-- Dialog dialog_end_test -->
        <v-layout row justify-center>
            <v-dialog v-model="dialog_end_test" persistent max-width="290">
               
                <v-card>
                    <v-card-title class="headline">Test beenden?</v-card-title>
                    <v-card-text>
                        Wenn Sie "Ok" klicken, wird der Test beendet und das Ergebnis wird abgespeichert.
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" flat @click="dialog_end_test = false">Ok</v-btn>
                        <v-btn color="green darken-1" flat @click="dialog_end_test = false">Abbrechen</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

        <!-- Liste der Verfügabren Tests-------------------------------------------------------->
        <div v-if="intro_stage" style="margin-left:10%; margin-right:10%">
            <br />
            <div style="display:flex;  justify-content :flex-start">
                <div>
                    <h2>Wichtige Informationen:</h2>
                    <p>
                        <ul>
                            <li>
                                Wenn Sie Tests auf dieser Webweite erstmals durchführen,
                                so führen Sie bitte zuerst den Demo-Test aus.
                            </li>
                            <li>
                                Für jede Frage ist mindestens eine Antwort richtig.
                                Wird keine Antwort ausgewählt, so wird die Frage mit 0 Punkten bewertet.
                            </li>
                            <li>
                                Jede Antwort ist mit dem entsprechenden Button zu speichern.
                            </li>
                            <li>
                                Für jede Auswahlmöglichkeit ist eine Wertung erreichbar,
                                wenn sie im Sinne der Frage selektiert oder auch nicht selektiert ist.
                                Falsche Selektionen oder Nicht-Selektionen führen zu Punktabzug ("Ratekorrektur")
                            </li>
                            <li>
                                <b>
                                    Verlassen Sie vor dem Klick auf "Abgeben"
                                    in keinem Fall die Seite.
                                    Ihre bisherigen Antworten sind sonst verloren.
                                </b>
                            </li>
                        </ul>
                    </p>
                </div>
            </div>
            <br />
            <hr />
            <br />
            <h2>Verfügbare Tests</h2>
            Sie können jeden Test maximal fünf mal ausführen. Die Zahl in der Klammer zeigt die bereits genutzten Versuche.
            <div v.if="is_created">
            <div v-for="test in available_tests" :key="test.id">
                <a @click="ui_event_use_test(test)">{{test.long_name}} ({{ test_history_count(test.id)}}{{test_history_result(test.id)}}) </a>
            </div>
            </div>

            <br />
            <hr />
            <br />
            <h2>Ihre Testhistorie</h2>
            <div style="max-width:800px">
                <v-data-table :headers="history_headers"
                              :items="fb_test_history"
                              class="elevation-1">
                    <template v-slot:items="props">
                        <td class="text-xs-left">{{ ui_helper_date(props.item.start_timestamp.toDate())}}</td>
                        <td class="text-xs-left">{{ props.item.test_name }}</td>
                        <td class="text-xs-center">{{ props.item.p }}</td>
                        <td class="text-xs-center">{{ props.item.p_max }}</td>
                    </template>
                </v-data-table>
            </div>
        </div>

        <!-- question_stage --------------------------------------------------------------------------->
        <div v-if="question_stage" style="margin-top:20px">

            <!-- Obere Zeile -->
            <div style="display:flex;  justify-content :flex-end">
                <v-btn text @click="ui_event_abgeben()">
                    Abgeben
                </v-btn>
               
            </div>

            <!-- Mittlerer Bereich -->
            <div style="display:flex; margin-top:20px">

                <!-- Linke Spalte mit dem Überblick der Fragen -->
                <div style="flex-basis:25%; margin-left:20px" v-if="question_stage">
                    <div v-for="(question, index) in test.questions" :key="question.title">
                        <div style="display:flex">
                            <a style="margin-bottom:0px; margin-right:10px" depressed small @click="ui_event_goto_question(index)">
                                <div v-if="index == currentQuestionIndex" style="color:blue">
                                    <b>{{index+1}} {{question.title}}</b>
                                </div>
                                <div v-if="index != currentQuestionIndex" style="color:grey">
                                    {{index+1}} {{question.title}}
                                </div>
                            </a>
                            <v-icon v-if="question.ok" small>done</v-icon>
                            <v-icon v-if="question.revisit" small>help_outline</v-icon>
                        </div>
                    </div>
                </div>

                <!-- Mittlerer Block mit den Fragen -->
                <div style="flex-grow:4; font-size:13pt">

                    <div style="margin-top:0px; background-color:antiquewhite">{{ test.questions[ currentQuestionIndex ].title }} </div><hr />
                    <div style="margin-top:20px">{{ test.questions[ currentQuestionIndex ].text }} </div>
                    <div style="margin-bottom:25px; margin-top:20px; font-size:10pt">
                        <div v-if="test.questions[ currentQuestionIndex ].max_selections == 1">Markieren Sie <b>eine</b> korrekte (oder am ehesten zutreffende) Antwort.</div>
                        <div v-if="test.questions[ currentQuestionIndex ].max_selections > 1">
                            Markieren Sie <b>alle zutreffenden</b> Antworten.
                            ({{test.questions[ currentQuestionIndex ].P}} Punkte)
                        </div>
                        <div v-for="(choice, index) in test.questions[ currentQuestionIndex ].choices" :key="choice.label">
                            <div v-on:click="checkbox_process_click(index)">
                                <v-checkbox class="pb-0 mb-0"
                                            color="primary"
                                            v-model="test.questions[ currentQuestionIndex ].selected"
                                            :label="choice.text"
                                            :value="choice.label"
                                            hide-details>
                                </v-checkbox>
                            </div>
                        </div>
                    </div>

                    <v-btn :disabled="dirty || currentQuestionIndex == 0" small color="primary" @click="ui_previous_question()" style="margin-left:-4px">
                      &lt;&lt;
                    </v-btn>
                    <v-btn :disabled=!dirty small color="primary" @click="ui_save()" style="margin-left: -4px">Antwort speichern </v-btn>
                    <v-btn :disabled=!dirty small color="primary" @click="ui_discard()" style="margin-left:-4px">Nicht speichern  </v-btn>
                    <v-btn :disabled="dirty || currentQuestionIndex == test.questions.length -1" small color="primary" @click="ui_next_question()" style="margin-left:-4px">>></v-btn>
                    <br />

                    <!-- 
                    <v-btn icon flat small v-bind:style="get_style(question.merker_ok,'merker_ok')"
                        @click="ui_question_toggle_ok()">
                        <v-icon>done</v-icon>
                    </v-btn>
-->
                    
                    <v-btn icon flat small v-bind:style="get_style(test.questions[ currentQuestionIndex ].merker_revisit, 'merker_revisit')"
                           @click="ui_question_toggle_revisit()">                       
                        <v-icon>help_outline</v-icon>                       
                    </v-btn>

                    <!--
                    <div>Current Selections : {{ JSON.stringify(question.selected) }} </div>
                    <div>Correct Selections :  {{ test.questions[currentQuestionIndex].correct_choices() }} </div>
                    <div>akt. Punkte : {{ test.questions[currentQuestionIndex].evaluation() }} </div>
                    <div>Max. Punkte : {{ test.questions[currentQuestionIndex].P }} </div>

                    <div>is_answered : {{ original_selected }} </div>
                    <div> original   : {{ original_selected }} </div>
                    <div>Correct     : {{ JSON.stringify(question.correct) }} </div>
                        -->
                </div>

            </div>
        </div>


        <!-- result_stage -->
        <div v-if="results_stage">
            <br />
            <h2>Ergebnis: {{P}} von  {{P_MAX}} Punkten.</h2>
            <br />
            <h3>Übersicht: </h3>
            <div style="max-width:600px">
                <v-data-table :headers="headers"
                              :items="corrections"
                              class="elevation-1">
                    <template v-slot:items="props">
                        <td class="text-xs-left">{{ props.item.nr }}</td>
                        <td class="text-xs-left">{{ props.item.title }}</td>
                        <td class="text-xs-center">{{ props.item.points }}</td>
                        <td class="text-xs-center">{{ props.item.P }}</td>
                    </template>
                </v-data-table>
            </div>

            <div v-for="(question, index) in test.questions" :key="question.title">

                <div class="headline" style="margin-top:50px; margin-right:50px; background-color:lightblue">Frage {{index+1}}: {{ test.questions[index].title }} </div>
                <div style="font-size:14px">{{ question.text }} </div>
                <p></p>

                <div style="margin-bottom:25px">
                    Markieren Sie alle zutreffenden Antworten.

                    <v-checkbox :color="get_correction_style(choice.correct)"
                                class="pb-0 mb-0"
                                v-for="choice in corrections[index].choices"
                                v-bind:key="choice.label"
                                v-model="question.selected"
                                multiple
                                :label="choice.text"
                                :value="choice.label"
                                hide-details>
                    </v-checkbox>
                </div>
                <div v-if="corrections[index].is_answered">
                    Punkte: <b>{{ corrections[index].points}}</b> von {{ question.P}}
                </div>
                <div v-if="!corrections[index].is_answered">
                    Punkte: <b>{{ corrections[index].points}}</b> von {{ question.P}}. (Frage wurde nicht beantwortet.)
                </div>
            </div>

        </div>
        <br />
    </div>

</template>

<script>
import { Utils } from "./../../classes/Utils.js";
import { the_test_directory } from "./Tests/the_test_directory.js";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { FirebaseTable } from "./../table/FirebaseTable";

export default {
  components: {},

  data: () => ({
    myHref: "empty",

    tName: "Quiz",
    fbTable: {},

    available_tests: [],

    events: [],

    // dialogs
    dialog_end_test: false,
    dialog_start_test: false,

    // Stage of the Quiz
    intro_stage: true,
    question_stage: false,
    results_stage: false,

    // Quiz-Data
    test: {},
    fb_test_history: [],
    P: 0,
    P_MAX: 0,

    // Database reference for the current test execution
    test_ref: {},

    // Result_list
    corrections: [],

    // Current-Question
    original_selected: [],
    currentQuestionIndex: 0,
    correct: 0,
    dirty: false,

    // UI-Helper
    ui_evaluation: "",
    is_created: false,

    headers: [
      { text: "Nr", value: "nr" },
      {
        text: "Frage",
        align: "left",
        sortable: false,
        value: "title",
      },
      { text: "Ihre Punktzahl", value: "points" },
      { text: "Erreichbare Punktzahl", value: "P" },
    ],

    history_headers: [
      { text: "Datum", value: "" },
      { text: "Test", align: "left", sortable: false, value: "test_title" },
      { text: "Ihre Punktzahl", value: "p" },
      { text: "Erreichbare Punktzahl", value: "p_max" },
    ],
  }),

  async created() {
    let user = firebase.auth().currentUser;

   
    // Hier eventuell die Tests filtern.
    this.available_tests = the_test_directory;

    this.fbTable = new FirebaseTable();

    // Read historical test data for user from firebase
    this.fb_test_history = await this.fbTable.get_lines_filtered(
      this.tName,
      "email",
      "==",
      user.email
      //   "start_timestamp"
    );

    this.available_tests.forEach((t) => {
      console.log(t.id, " : ", this.test_history_count(t.id));
    });

    if (!this.fb_test_history) {
      this.$store.commit(
        "setSnackbarText",
        "Technischer Fehler: Test kann nicht gestartet werden."
      );
    }

    // Sort the test history
    this.fb_test_history.sort(function(a, b) {
      return b.start_timestamp.toDate() - a.start_timestamp.toDate();
    });

    this.is_created = true;
  },

  computed: {},

  methods: {
    ui_helper_date(date) {
      return Utils.getGermanDate(date);
    },

   
    ui_event_goto_question(i) {
      if (this.dirty) return;

      if (i >= this.test.questions.length) {
        i = 0;
      }

      if (i < 0) {
        i = this.test.questions.length - 1;
      }

      this.currentQuestionIndex = i;
      this.original_selected = [...this.test.questions[i].selected];
    },

    ui_previous_question() {
      this.ui_event_goto_question(this.currentQuestionIndex - 1);
    },

    ui_next_question() {
      this.ui_event_goto_question(this.currentQuestionIndex + 1);
    },

    ui_save() {
      this.test.questions[this.currentQuestionIndex].selected = [
        ...this.test.questions[this.currentQuestionIndex].selected,
      ];
      this.test.questions[this.currentQuestionIndex].ok =
        this.test.questions[this.currentQuestionIndex].selected.length > 0;
      this.dirty = false;
      this.ui_event_goto_question(this.currentQuestionIndex);
    },

    ui_isAdmin() {
      return this.$store.getters.isAdmin;
    },

    ui_discard() {
      this.test.questions[this.currentQuestionIndex].selected = [...this.original_selected];
      this.dirty = false;
      this.$forceUpdate();
    },

    ui_event_use_test(test) {
      this.test = test;

      if (this.$store.getters.isAdmin) {
        this.ui_start_test("ok");
      } else if (test.id == "test_demo") {
        if (this.test_history_count(this.test.id) < 20) {
          // Keine Limitierung für den Demotest; start test w/o asking
          this.ui_start_test("ok");
        } else {
          this.$store.commit(
            "setSnackbarText",
            "Mehr als 5 Versuche sind nicht möglich."
          );
        }
      } else if (this.test_history_count(this.test.id) >= 5) {
        this.$store.commit(
          "setSnackbarText",
          "Mehr als 5 Versuche sind nicht möglich."
        );
      } else {
        this.ui_start_test("ok");
      }
    },

    ui_question_toggle_revisit() {
      this.test.questions[this.currentQuestionIndex].revisit = !this.test
        .questions[this.currentQuestionIndex].revisit;
      this.$forceUpdate();
    },

    ui_question_toggle_ok() {
      this.test.questions[this.currentQuestionIndex].ok = !this.test.questions[
        this.currentQuestionIndex
      ].ok;
      this.$forceUpdate();
    },

    async ui_start_test(action) {
      if (action === "ok") {
        // Close dialog
        this.dialog_start_test = false;

        // Generate and load the test...
        console.log("Calling TestFactory with :", this.test_id);
        var user = firebase.auth().currentUser;
        var email = user.email;
        //console.log("Mail : ", this.test_name);
        // Get a pushId for all data of this test
        this.testRef = await this.fbTable.write(this.tName, {
          email: email,
          test_id: this.test.id,
          test_name: this.test.long_name,
          start_timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        });

        if (!this.testRef) {
          // Something went wrong
          this.$store.commit(
            "setSnackbarText",
            "Technischer Fehler: Test kann nicht gestartet werden."
          );
          return;
        }

        //   this.fbTable.get_and_increment(this.tName, "doc_count")
        console.log("Docref :", this.testRef);

        // OK, jetzt geht es zum Test....
        this.ui_event_goto_question(0);
        this.intro_stage = false;
        this.question_stage = true;
      } else {
        this.dialog_start_test = false;
      }
    },

    async ui_event_abgeben() {
      console.log("Abgeben-----------------:");
      this.question_stage = false;
      this.results_stage = true;

      let correction;
      let i = 1;

      this.P = 0;
      this.P_MAX = 0;

      this.test.questions.forEach((q) => {
        correction = q.correction();

        this.P = this.P + correction.points;
        this.P_MAX = this.P_MAX + correction.P;

        // Nur für Tabelle
        correction.nr = i++;

        this.corrections.push(correction);
        console.log(correction.is_answered);
      });

      let result = await this.testRef
        .set(
          {
            abgabe_timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            p: this.P,
            p_max: this.P_MAX,
          },
          { merge: true }
        )
        .then(function(docRef) {
          console.log("   Success : ", docRef);
          return 1;
        })
        .catch(function(error) {
          console.error("   Failure : ", error);
          return -1;
        });

      if (result < 0) {
        // Something went wrong
        this.$store.commit(
          "setSnackbarText",
          "Technischer Fehler: Testergebnis kann nicht gespeichert werden."
        );
        return;
      }
    },

    checkbox_process_click(index) {
      this.dirty = true;

      // For single choice quesions: set only the current answer
      if (this.test.questions[this.currentQuestionIndex].max_selections == 1) {
        this.test.questions[this.currentQuestionIndex].selected = [
          this.question.choices[index].label,
        ];
      }

      this.$forceUpdate();
    },

    get_style(mark, merker) {
      if (mark) {
        return merker == "merker_revisit"
          ? { color: "red" }
          : { color: "green" };
      } else {
        return { color: "grey" };
      }
    },

    get_correction_style(correct) {
      return correct ? "green" : "red";
    },

    test_history_count(test_id) {
      var count = 0;
      this.fb_test_history.forEach((h) => {
        if (h.test_id == test_id) count++;
      });
      return count;
    },

    test_history_result(test_id) {
      var result = false;
      this.fb_test_history.forEach((h) => {
        if (h.test_id === test_id) {
          if (h.p && h.p >= h.p_max / 2) result = true;
        }
      });
      return result ? ", passed" : "";
    },
  },
};
</script>
